import React from 'react';
import './TermsConditions.css';

const TermsConditions = () => {
  return (
    <div className="terms-conditions-page">
      <div className="terms-container">
        <h1 className="terms-title">Terms and Conditions</h1>
        
        <div className="terms-intro">
          <p>
            PhoneVue Private Limited (hereinafter referred to as "we") shall be responsible for communication between we and users of this application/app (hereinafter referred to as "you") regarding PhoneVue (hereinafter referred to as "this App") (hereinafter referred to as the "Terms of Use") are defined as follows.
          </p>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 1. Consent to Terms of Use:</h2>
          <ol className="article-list">
            <li>
              You are deemed to have agreed to these Terms of Use by performing the procedure for agreeing to these Terms of Use displayed on this App or by installing this App on your smartphone, and it is assumed that a contract for the use of this App has been concluded between we and you.
            </li>
            <li>
              If you do not agree to these Terms of Use, you cannot use this App or the services provided by this App.
            </li>
            <li>
              If you are a minor, please obtain the consent of your parents or other legal representative before agreeing to these Terms of Use.
            </li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 2. About this application/App:</h2>
          <p className="article-intro">This article lists the services provided by the application/App:</p>
          <ol className="article-list">
            <li>Diagnosis of smartphone functions</li>
            <li>Smartphone battery deterioration diagnosis</li>
            <li>Future prediction diagnosis of smartphone batteries (including user type diagnosis)</li>
            <li>Report functions for each diagnosis result</li>
            <li>My Page functions</li>
            <li>Providing information (store information, etc.) as User Profile</li>
            <li>Other accompanying services</li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 3. Privacy Policy:</h2>
          <p className="article-text">
            For the handling of your privacy regarding this application/App and the services provided by this application/App, please refer to our separate privacy policy.
          </p>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 4. User Account and use of this application/App:</h2>
          <ol className="article-list">
            <li>
              When creating an user account for this application/App or using this application/App, please do not make false statements and provide us with accurate information.
            </li>
            <li>
              If there is a change in your name, e-mail address, etc., please promptly update the user account of this application/App to the latest information.
            </li>
            <li>
              You are responsible for strictly managing information related to the user account of this application/App, including ID and password, and do not disclose it to the third parties.
            </li>
            <li>
              You are prohibited from allowing others to use your user account on the App or similar actions.
            </li>
            <li>
              We will not be held responsible to you for any damages you may incur by violating this article.
            </li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 5. Precautions regarding installation and use of this App</h2>
          <ol className="article-list">
            <li>
              It is your responsibility to download, install and use this App on your smartphone. We do not guarantee anything about this App or the services provided by this App, and we are not obligated to repair any defects including bugs. Even if you cause damage to a third party in connection with this App or the service provided by this App, we do not take any responsibility.
            </li>
            <li>
              You are responsible for all costs, including communication charges, incurred in downloading, installing, using, this App and services provided by this App.
            </li>
            <li>
              Due to the usage environment of this App or services provided by this App, or due to defects including bugs in this App or services provided by this App, this App or services provided by this App may not function properly. Malfunctions may also occur in the smartphone, the software in the smartphone, or the data in the smartphone. In this case, we will have no liability to you.
            </li>
            <li>
              We do not guarantee the reliability, accuracy, usefulness, safety, etc. of this App or the services provided by this App. We will not be held responsible for any damages you may incur in connection with these.
            </li>
            <li>
              This App can be used for free.
            </li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 6. Change, suspension, termination, etc. of this App</h2>
          <ol className="article-list">
            <li>
              We may change, suspend, or terminate the provision of this App or the services provided by this App at any time without notice to you or your consent. In this case, we will have no liability to you.
            </li>
            <li>
              This App and the services provided by this App after the change will be treated as this App and services provided by this App under these Terms of Use, and these Terms of Use will also apply to these.
            </li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 7. Attribution of Rights</h2>
          <ol className="article-list">
            <li>
              All rights contained in this App, including copyrights, patent rights, and trademark rights, belong to us.
            </li>
            <li>
              You may use the App only for the purposes specified by us.
            </li>
            <li>
              Regardless of the reason, if we instruct you to stop using this App or uninstall this App, you shall promptly follow this instruction. We will not be held responsible for any damages you may incur in connection with these.
            </li>
            <li>
              You must not perform any act that infringes on the rights of this App, including transfer, modification, imitation of functions and display screens, combination with other software, and translation of this App.
            </li>
            <li>
              You may not reverse engineer, reverse assemble, reverse compile, or otherwise engage in any act equivalent to the above.
            </li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 8. Prohibited Acts</h2>
          <p className="article-intro">
            In connection with this App and the services provided by this App, you must not engage in any of the following acts. If we recognize that you have committed any of these acts, we may suspend or terminate your use of this App or the services provided by this App, prohibit re-registration, terminate the usage contract, claim damages, or take any other appropriate action against you. In this case, we will have no liability to you.
          </p>
          <ol className="article-list">
            <li>Violent, threatening, or fraudulent behavior</li>
            <li>Defamation, insult, obstruction of business, defamation of credibility</li>
            <li>Infringement of intellectual property rights</li>
            <li>Infringement of moral rights including author's moral rights and privacy rights</li>
            <li>Acts that violate these Terms of Use</li>
            <li>Violations of laws and regulations</li>
            <li>Acts that infringe or may infringe the rights or interests of us or our affiliates</li>
            <li>Acts of aiding or abetting any of the above acts</li>
            <li>In addition to the above, acts that we judge to be inappropriate</li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 9. Disclaimer</h2>
          <ol className="article-list">
            <li>
              We have no liability where explicitly stated in the Terms of Use.
            </li>
            <li>
              We are not responsible for damages caused by your own actions (including prohibited acts) or third parties (e.g., computer viruses, spyware, unauthorized access, hacker actions).
            </li>
            <li>
              We are not responsible for damages due to telecom failure, carrier issues, or events not attributable to either party, such as natural disasters (earthquakes, fires, floods, hurricanes, typhoons, epidemics), explosions, strikes, wars, civil commotions, government demands, acts of civil or military authorities, force majeure, bank system failures, communication failures, system failures, and smartphone failures.
            </li>
            <li>
              Even if the agreement is a consumer contract, liability for default or tort from special circumstances (foreseeable damage) is disclaimed. Compensation for damages due to negligence (excluding gross negligence) is limited to the usage fees received in the month the damage occurred. Further disclaims responsibility if it falls under other exemption reasons in the article.
            </li>
            <li>
              We disclaim any guarantees regarding the accuracy and completeness of the App, and any express or implied warranties of merchantability or fitness for a particular purpose. It also states no endorsement of other companies/products, no tax/investment advice, and no securities trading/investment recommendations are provided.
            </li>
            <li>
              You are responsible for all actions and results based on information obtained from the App, and cannot make objections or claims against us.
            </li>
            <li>
              We disclaim control over external websites linked from the application and responsibility for their availability, content, advertisements, products, or services. Consequently, we disclaim responsibility for any damages (direct or indirect) caused by or related to such external content.
            </li>
            <li>
              Advertisements (including sweepstakes) and transactions with advertisers within the App are the responsibility of you and the advertiser. You and advertiser are responsible for payments, contract conditions, and guarantees. We disclaim responsibility for damages caused by transactions or the mere posting of advertisements.
            </li>
            <li>
              We disclaim guarantees for the absence of errors, bugs, logical errors, malfunctions, interruptions, or other defects, reliability, accuracy, completeness, or effectiveness of the App. The App is provided "as is," without warranty of perfect fitness for a particular purpose, usefulness, security, title, or non-infringement.
            </li>
            <li>
              We disclaim responsibility for any problems resulting from installing the App or other programs/updates provided by us.
            </li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 10. Entire agreement, severability, non-waiver</h2>
          <ol className="article-list">
            <li>
              These Terms of Use constitute the entire agreement between the parties, superseding any prior oral or written agreements, representations, and understandings regarding the same matters.
            </li>
            <li>
              If any provision or portion of these Terms of Use is found invalid or unenforceable, the remaining provisions will remain in full force and effect. Both parties are obligated to negotiate revisions to reflect the original intent as much as possible for the invalid or unenforceable sections.
            </li>
            <li>
              A failure or delay by either party in exercising any right or remedy under these Terms of Use does not constitute a waiver of that right or remedy, and has no further consequences. You can still exercise your rights or remedies.
            </li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 11. Service provision</h2>
          <p className="article-text">
            The email address you have registered with us be regarded as notifying you for communication that arrives to you when it should normally arrive or if it is delayed or fails to arrive despite our best of efforts in notifying you regarding the services for this App.
          </p>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 12. Inquiry or Contact Us</h2>
          <p className="article-text">
            If you have any questions, opinions, concerns, etc. related to this App or services provided by this App, please send an email to the following email address.
          </p>
          <p className="article-text" style={{ marginTop: '0.5rem' }}>
            <strong>email address : </strong>info@phonevue.in
          </p>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 13. Notification, Publication, and Modification of Terms of Use</h2>
          <ol className="article-list">
            <li>
              Notifications or public announcements regarding these Terms of Use or any changes thereof will be made by posting on the App, posting on our website, sending e-mails, or other appropriate means.
            </li>
            <li>
              We may change these Terms of Use at any time at our discretion.
            </li>
            <li>
              As a general rule, changes to these Terms of Use shall be made without your consent, and you have to accept this. However, as these Terms of Use changes or gets updates, we may ask you to agree to the changed Terms of Use.
            </li>
            <li>
              If you do not agree to the changed Terms of Use, please uninstall this App immediately. If you follow the procedures for agreeing to the changed Terms of Use displayed on this App, or if you use this App after the Terms of Use have been changed, you will be deemed to have agreed to the changed Terms of Use. It is deemed that a contract for using this application/App has been concluded between us and you in accordance with the terms of the changed Terms of Use.
            </li>
          </ol>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 14. Governing law</h2>
          <p className="article-text">
            Laws and regulations of India shall apply to the conclusion, validity, interpretation, performance, termination and dispute resolution of these Terms of Use.
          </p>
        </div>

        <div className="terms-article">
          <h2 className="article-title">Article 15. Agreed Jurisdiction</h2>
          <p className="article-text">
            In the unlikely event that a legal dispute arises regarding these Terms of Use, the New Delhi, India. Summary Court or the New Delhi District Court shall be the agreed exclusive court of jurisdiction for the first instance, such as a petition for arbitration, preservation, litigation, or execution, etc., depending on the amount of the complaint.
          </p>
        </div>

        <div className="terms-date">
          <p className="date-text">Dated : 16th February 2024</p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
